import { makeStyles } from 'tss-react/mui'

export const getOrMakeSimpleAlertStyles = makeStyles()(() => ({
    simpleAlertPane: {
        width: 444
    }
}))